export default "__VITE_ASSET__Dbl$1rRU__"